import type { TotalsWithLabor } from '../types/GroupsArrayType';

const totalsWithLaborModel: TotalsWithLabor = {
  laborCost: 0,
  laborPercentage: 0,
  salaryCost: 0,
  wagesCost: 0,
  hours: 0,
  noShows: 0,
  paidMinutes: 0,
  shifts: 0,
  sickCallouts: 0,
};

export default totalsWithLaborModel;
